// Controles compartilhados dos widgets "Top offenders" do Dashboard.
// - TopNSelector: dropdown 5/10/25/50
// - TimeRangeSelector: pill buttons 1h | 24h | 7d
//
// Pattern alinhado com Splunk/Elastic dashboards (industry).

import type { DashboardWindow } from '../services/dashboard';

interface TopNSelectorProps {
  value: number;
  onChange: (n: number) => void;
  options?: number[];
  id?: string;
}

export function TopNSelector({
  value,
  onChange,
  options = [5, 10, 25, 50],
  id,
}: TopNSelectorProps) {
  return (
    <label className="inline-flex items-center gap-2 text-xs text-gray-400">
      Top
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
        className="bg-gray-800 border border-gray-700 rounded px-2 py-1 text-gray-200"
      >
        {options.map((n) => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>
    </label>
  );
}

interface TimeRangeSelectorProps {
  value: DashboardWindow;
  onChange: (w: DashboardWindow) => void;
  options?: DashboardWindow[];
}

export function TimeRangeSelector({
  value,
  onChange,
  options = ['1h', '24h', '7d'],
}: TimeRangeSelectorProps) {
  return (
    <div className="inline-flex bg-gray-800 border border-gray-700 rounded overflow-hidden">
      {options.map((w) => (
        <button
          key={w}
          onClick={() => onChange(w)}
          className={`px-3 py-1 text-xs ${
            w === value
              ? 'bg-blue-600 text-white'
              : 'text-gray-400 hover:bg-gray-700'
          }`}
          aria-pressed={w === value}
        >
          {w}
        </button>
      ))}
    </div>
  );
}
